// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorAPI_errorContainer__NZakl","errorContainerLandscape":"ErrorAPI_errorContainerLandscape__YZ_fB"};